import { render } from "./ContractItemV2.vue?vue&type=template&id=1801077d&scoped=true"
import script from "./ContractItemV2.vue?vue&type=script&lang=js"
export * from "./ContractItemV2.vue?vue&type=script&lang=js"

import "./ContractItemV2.vue?vue&type=style&index=0&id=1801077d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1801077d"]])

export default __exports__